<!-- RANGE DATE PICKER -->
<div class="datepicker-trigger {{ customClass }}" [class.focused]="picker.opened" (click)="open()">
  <!-- ⚠️ IMPORTANT!
      We hide this template mat-date-range-input but only with opacity and pointer events none
      The popup needs it to calculate the position
    -->

  <mat-date-range-input class="hide" [rangePicker]="picker">
    <input class="input-datepicker" [(ngModel)]="selectedStartDate" [readonly]="true" matStartDate />
    <input class="input-datepicker" [(ngModel)]="selectedEndDate" [readonly]="true" (ngModelChange)="endDateUpdated()" matEndDate />
  </mat-date-range-input>

  <!-- DatePicker popup -->
  <mat-date-range-picker #picker (closed)="focusChange.emit(false)"></mat-date-range-picker>

  <!--  ICON -->
  <div class="f-icon icon-date-picker"></div>

  <!-- Placeholder -->
  <div *ngIf="!(selectedStartDate || selectedEndDate); else rangeLabel" class="placeholder">
    <ng-container *ngIf="placeholder !== null; else defaultPlaceholder">
      {{ placeholder }}
    </ng-container>
    <ng-template #defaultPlaceholder>
      {{ 'ui2-datepicker.inputPlaceholderRange' | translate }}
    </ng-template>
  </div>

  <!-- Label -->
  <ng-template #rangeLabel>
    <div class="label">{{ selectedStartDate | date : 'MMM d, y' }} - {{ selectedEndDate | date : 'MMM d, y' }}</div>
  </ng-template>

  <!-- Clear button -->
  <div
    *ngIf="clearable && (selectedStartDate || selectedEndDate)"
    class="icon2-x16-close-s"
    (click)="clear(); $event.stopPropagation()"
  ></div>

  <!-- CHEVRON
    we show either one or another with CSS
  -->
  <!-- normal -->
  <div class="icon2-x16-chevron-l" [class.open]="picker.opened"></div>
  <!-- micro -->
  <div class="icon2-x16-micro-chevron-m" [class.open]="picker.opened"></div>
</div>
